var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.3 55",
    style: {
      enableBackground: "new 0 0 69.3 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E02020;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_3---videos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_3---V\\xEDdeos---post",
    transform: "translate(-111.000000, -1130.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(111.000000, 1119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(34.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M3.2,38c0,8,6.5,14.5,14.5,14.5S32.2,46,32.2,38c0-7.8-6.2-14.2-14-14.4 c0.9-6.3,5.4-14.1,12.3-21C18,2.6,3.2,20.6,3.2,38L3.2,38z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st0",
    d: "M17.6,52.5c8,0,14.5-6.5,14.5-14.5c0-7.8-6.2-14.2-14-14.5c0.9-6.4,5.5-14.1,12.4-21 C18,2.5,3.2,20.5,3.2,38C3.2,46,9.6,52.5,17.6,52.5L17.6,52.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIco);
export default __webpack_public_path__ + "static/media/quote-ico.7cc2a85a5d82fe1265a8997b733ddf35.svg";
export { ForwardRef as ReactComponent };